import { BooleanField, ChipField, Datagrid, List, NumberField, ReferenceField, TextField } from 'react-admin';
import { useLocation } from 'react-router-dom';

const MediaCategory = () => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const isGlobalFromQuery = params.get('is_global') === 'true';
	// ?type=podcast → podcast categories (the API defaults to type 'video')
	const typeFromQuery = params.get('type') === 'podcast' ? 'podcast' : undefined;
	const filter = { ...(isGlobalFromQuery ? { is_global: true } : {}), ...(typeFromQuery ? { type: typeFromQuery } : {}) };

	return (
		<List filter={Object.keys(filter).length ? filter : undefined}>
			<Datagrid rowClick="edit">
			<TextField source="hebrew_name" />
			<TextField source="english_name" />
			<BooleanField source="visible" />
			<TextField source="type" />
			<NumberField source="priority" label="עדיפות" />
			<NumberField source="age.from" />
			<ReferenceField source="parent_category" reference="vod/categories">
				<ChipField source="hebrew_name" />
			</ReferenceField>
			</Datagrid>
		</List>
	);
};

export default MediaCategory;
